<template>
    <v-toolbar flat>
      <v-btn v-if="isOnMobile" icon class="mr-4" @click="drawer=!drawer">
        <v-icon>mdi-menu-{{ drawer ? 'close' : 'open' }}</v-icon>
      </v-btn>
      <v-text-field
        :label="$t('vmail.listToolbar.labels.search')"
        dense
        flat
        outlined
        clearable
        :placeholder="$t('vmail.searchPlaceholder')"
        prepend-icon="mdi-magnify"
        ref="search"
        v-model="searchText"
        @click:append="clearText"
        data-testid="search-field"
        :style="isOnMobile ? 'width: 100%;' : 'max-width: 400px;'"
        class="mt-8"
      />
      <v-menu
        v-model="menu"
        v-if="!isOnMobile"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="290px">
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="date"
            outlined
            dense
            clearable
            :label="$t('vmail.listToolbar.labels.dateLabel')"
            :placeholder="$t('vmail.listToolbar.labels.datePlaceholder')"
            class="mx-2 mt-8"
            prepend-icon="mdi-calendar"
            style="max-width: 400px;"
            readonly
            v-on="on"
            ></v-text-field>
        </template>
        <v-date-picker :value="date" @input="onSelectDate"
          :max="maxDate" no-title>
        </v-date-picker>
      </v-menu>
      <v-spacer></v-spacer>
      <div v-if="!isOnMobile">
        <v-autocomplete
          :label="$t('vmail.listToolbar.labels.folder')"
          v-model="folder"
          outlined
          dense
          flat
          :placeholder="$t('vmail.listToolbar.labels.folder')"
          style="max-width: 230px;"
          class="mt-8 pr-2"
          :items="folders"
          item-text="text"
          item-value="name"
          @change="onFolderSelect"
        />
      </div>
      <div v-if="!isOnMobile">
        <v-autocomplete
          :label="$t('vmail.listToolbar.labels.category')"
          v-model="category"
          :items="categoriesWithLocales"
          item-text="text"
          item-value="name"
          outlined
          dense
          flat
          :placeholder="$t('vmail.listToolbar.labels.category')"
          style="max-width: 230px;"
          class="mt-8"
          @change="onSelectCategory"
        />
      </div>
    </v-toolbar>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import MixinVoicemailsFolders from '@/mixins/voicemails/folders'
import { formatDateISO } from '@/filters/format_date'

export default {
  name: 'msgs-header',
  mixins: [
    MixinVoicemailsFolders
  ],
  data () {
    return {
      date: null,
      menu: false,
      folder: null,
      category: 'all'
    }
  },
  computed: {
    ...mapGetters({
      categories: 'voicemails/categories',
      placeholder: 'search/placeholder',
      getSearchText: 'search/searchText',
      drawerState: 'voicemails/drawerState'
    }),
    drawer: {
      get () {
        return this.drawerState
      },
      set (drawerState) {
        this.setDrawerState(drawerState)
      }
    },
    searchText: {
      get () {
        return this.getSearchText
      },
      set (searchText) {
        this.setSearchText(searchText)
      }
    },
    categoriesWithLocales () {
      return this.categories.map(category => ({
        text: this.$t(`vmail.categories.${category}`),
        name: category
      }))
    },
    maxDate: function () {
      return this.toLocalISOString() || formatDateISO()
    },
    isOnMobile () { return this.$vuetify.breakpoint.mobile }
  },
  watch: {
    '$route.params.folder': {
      immediate: true,
      handler (newFolder) {
        if (newFolder !== this.folder) {
          if (newFolder === undefined) {
            newFolder = null
          }
          this.folder = newFolder
        }
      }
    },
    date: {
      immediate: false,
      handler (date) {
        this.setFilter({ ...this.filter, date: date })
        this.reloadPage()
      }
    }
  },
  methods: {
    ...mapActions({
      setSearchText: 'search/setSearchText',
      reloadPage: 'voicemails/reloadPage',
      setFilter: 'voicemails/setFilter',
      setDrawerState: 'voicemails/setDrawerState',
      setPage: 'voicemails/setPage'
    }),
    clearText () {
      this.setSearchText('')
    },
    onFolderSelect (folder) {
      if (folder !== this.$route.params.folder) {
        this.$router.push({ name: 'voicemails', params: { folder: folder } })
        this.reloadList()
      }
    },
    toLocalISOString (date = new Date()) {
      const offsetMs = date.getTimezoneOffset() * 60000
      const localTime = new Date(date.getTime() - offsetMs)
      return localTime.toISOString().slice(0, -1)
    },
    onSelectCategory (category) {
      this.setFilter({ ...this.filter, category: category })
      this.reloadPage()
    },
    onSelectDate (date) {
      this.date = date
    },
    async reloadList () {
      await this.setPage(1)
      this.reloadPage()
    }
  }
}
</script>

<style>

</style>
